import business from '@/utils/business'
export function ClientList(data){
	return business.post('/client/dict', data)
}


export function List(data){
	return business.post('/client/list', data)

}

export function EmpUpload(data){
	return business.post('/client-employee/wxhr-upload', data)

}



// WEBPACK FOOTER //
// ./src/api/Hrclient.js